import { useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { ListGroup, ListGroupItem } from 'reactstrap'
import BasicInformation from './BasicInformation'
import ChangePassword from './ChangePassword'
import MyDevices from './MyDevices'
import TwoFactorAuthentication from './TwoFactorAuthentication'

export default function UserProfile(props) {
  console.log('UserProfile rendered')

  const sectionList = [
    { text: 'Basic Information', component: <BasicInformation /> },
    { text: 'Change Password', component: <ChangePassword /> },
    { text: 'My Devices', component: <MyDevices /> },
    { text: 'Two-factor Authentication', component: <TwoFactorAuthentication /> }
  ]

  const [selectedSection, setSelectedSection] = useState(0)
  const params = useParams()
  console.log(params)


  function sectionClicked(e, sectionNumber) {
    console.log('UserProfile.sectionClicked', sectionNumber)
    e.preventDefault()
    setSelectedSection(sectionNumber)
  }

  const selectedStyle = { borderTop: 'none', borderLeft: '5px solid #0969DA', borderRight: 'none', backgroundColor: '#F0F2F5' }
  const unSelectedStyle = { borderTop: 'none', borderLeft: 'none', borderRight: 'none' }

  const sections = []
  for (let i = 0; i < sectionList.length; i++) {
    let section = sectionList[i]
    let style = i === selectedSection ? selectedStyle : unSelectedStyle
    sections.push(
      <Link key={i} onClick={(e) => sectionClicked(e, i)} style={{ textDecoration: 'none' }} data-cy={`user-profile-${section.text.toLowerCase().replaceAll(' ', '-')}`}>
        <ListGroupItem action style={style}>
          {section.text}
        </ListGroupItem>
      </Link>
    )
  }

  return (
    <div style={{ height: '100%', padding: '20px' }}>
      <div style={{ border: '1px solid #ccc', height: '100%', display: 'flex' }}>
        <div style={{ width: '250px', borderRight: '1px solid #CCC', height: '100%', display: 'inline-block', verticalAlign: 'top', backgroundColor: 'white' }}>
          <ListGroup>
            {sections}
          </ListGroup>
        </div>
        <div style={{ display: 'inline-block', width: '100%', overflow: 'auto' }}>
          {sectionList[selectedSection].component}
        </div>
      </div>
    </div>
  )
}
